import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { Form } from './components';
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})

analytics.page()

const PasswordResetCover = ({handleCurrentStep, secondState, firstState}) => {

  return (
  <Form handleCurrentStep={handleCurrentStep} 
  firstState={firstState}
  secondState = {secondState}/>

);
};

export default PasswordResetCover;
